<template>
  <div class="policy-wrap">
    <h3 class="center">
      熊猫签证用户协议<br /><small>（本协议于2016年6月1日发布）</small>
    </h3>
    <h4>1、服务条款的确认和接纳</h4>
    <p>
      熊猫签证由深圳市六六六网络服务有限公司运营，用户按照注册页面提示填写信息、阅读同意本协议且完成全部注册程序，或以熊猫签证允许的其他方式成为熊猫签证用户，即表示用户已知晓并同意按照本服务条款就使用熊猫签证提供的服务与深圳市六六六网络服务有限公司达成具有法律约束力的协议。
    </p>

    <h4>2、服务提供</h4>
    <p>
      熊猫签证通过国际互联网络为用户提供网络服务。服务内容包括但不限于提供信息资讯、销售商品或服务等，熊猫签证提供的部分服务由具有相应资质的第三方提供。
    </p>
    <p>
      熊猫签证不保证网络服务一定会满足用户的所有使用要求，也不保证网络服务不会短暂中断，对网络服务的及时性、安全性、准确性也不作担保。熊猫签证保留随时修改或中断服务的权利，且无需提前知会用户。
    </p>
    <p>
      为使用上述服务，用户必须自行配备访问国际互联网所需软硬件设备并承担相关费用，同时需向熊猫签证提供详尽准确的个人资料并在此后不断更新个人资料。
    </p>

    <h4>3、服务条款的修改</h4>
    <p>
      熊猫签证有权根据运营需要随时对服务条款进行修改，修改后的服务条款一经在熊猫签证上公示即生效，熊猫签证不再另行向用户发送修改通知。用户可随时登录熊猫签证查阅最新服务条款，用户有义务不时关注并阅读最新版的服务条款及网站公告。用户如果不同意服务条款的修改，可以主动取消或放弃已经获得的网络服务；如果用户继续享用网络服务，则视为用户已经接受服务条款的修改。
    </p>

    <h4>4、知识产权声明</h4>
    <p>
      熊猫签证对所提供的网络服务及网络服务所使用的软件系统（包含受知识产权或其他法律保护的资料）享有相应的权利。
    </p>
    <p>
      熊猫签证发布的任何资讯及内容，受到著作权法、商标法、专利法或其他法律的保护；未经熊猫签证明示授权许可，用户不得进行修改、出租、散布或衍生其他作品。
    </p>
    <p>
      熊猫签证的名称、标志、图片以及熊猫签证上的其他内容，均由熊猫签证或相关内容提供方享有知识产权。未经熊猫签证合法书面授权，任何人不得使用、复制或用作其他用途。
    </p>
    <p>
      用户应对其通过本网站上传或发布内容的真实性、合法性负责，保证对该等内容拥有完整的、无瑕疵的所有权和知识产权或拥有完整的授权，并不存在任何侵犯第三方合法权益的情形，包括但不限于著作权、肖像权、商标权、专利权、企业名称权、商号权、商业秘密、个人隐私等权利。所有因用户非法上传内容而给任何第三方或熊猫签证造成损害的均由用户承担全部责任，熊猫签证不承担任何责任。
    </p>

    <h4>5、用户信息保护</h4>
    <p>
      用户使用熊猫签证服务过程中，根据具体交易需要，用户需向熊猫签证提供个人信息。尊重用户个人隐私是熊猫签证的一项基本政策，熊猫签证将采取一切必要合理的措施保护用户提供的个人信息，未经用户同意熊猫签证不会向第三方透露用户的个人信息，但以下情况除外：⑴经您事先同意，向第三方披露。(2)根据法律的有关规定或者行政或司法机构的要求，向第三方或者行政、司法机构披露。(3)如您出现违反中国有关法律、法规或者熊猫签证服务协议或相关规则的情况，需要向第三方披露。(4)为提供您所要求的产品和服务，而必须和第三方分享您的个人信息。(5)其它熊猫签证根据法律、法规或者网站政策认为合适的披露。
    </p>
    <p>
      以下情况造成个人信息外泄的，熊猫签证不负任何责任：(1)用户将个人密码告知他人或与他人共享注册账户。(2)政府部门、司法机关等依照法定程序要求本网站披露个人信息的。(3)任何由于计算机问题、黑客攻击、计算机病毒侵入或发作、因政府部门管制而造成的暂时性关闭等影响网络正常经营的不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等。(4)由于本网站链接的其他网站所造成的个人信息泄露。
    </p>

    <h4>6、用户的账号，密码和安全性</h4>
    <p>
      用户注册后将获得熊猫签证的账号及密码，用户应当妥善账号及密码并对通过账号进行的行为负责。用户若发现任何非法使用用户账号或安全漏洞，应立即通告熊猫签证。
    </p>

    <h4>7、邮件、短彩信服务规则</h4>
    <p>
      用户同意熊猫签证有权通过邮件、短信、彩信等形式向用户发送订单信息、促销活动公告等，如果用户不想接收来自熊猫签证除订单信息以外的邮件和短信，用户需及时通知熊猫签证。
    </p>

    <h4>8、责任限制</h4>
    <p>
      熊猫签证对于用户因使用网络服务而遭受的任何直接、间接、偶然、特殊及继起的损害不承担责任，亦不对用户所发布信息的删除或储存失败承担责任。
    </p>

    <h4>9、用户义务</h4>
    <p>用户使用网络服务过程中必须遵循以下义务：</p>
    <p>
      发布信息时必须符合中国有关法规，不传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽等信息资料。
    </p>
    <p>不使用网络服务进行非法用途，如教唆他人实施犯罪或侵权行为。</p>
    <p>不干扰或破坏网络服务或与网络服务相连的服务器和网络。</p>
    <p>遵守所有涉及使用网络服务的网络协议、规定和程序。</p>
    <p>
      用户须对自己在使用服务过程中的行为承担法律责任。若用户违反上述任何义务，熊猫签证有权作出独立判断立即取消用户服务账号，并保留追究用户法律责任的权利。用户在熊猫签证的使用记录将作为用户违反法律的证据。
    </p>

    <h4>10、法律适用及争议解决</h4>
    <p>
      邮件服务条款要与该国的国家法律解析一致，包括法律条款中有争议抵触的内容。用户和深圳市六六六网络服务有限公司一致同意服从法院的管辖。若有任何服务条款与法律相抵触，那这些条款将按尽可能接近的方法重新解析，而其它条款则保持对用户产生法律效力和影响，因用户解释本协议或通过熊猫签证预订任何产品而导致的争议，将同意接受深圳市南山区人民法院的管辖。
    </p>

    <p>&nbsp;</p>
  </div>
</template>

<script>
import utils from '../services/tools.js';

export default {
  created() {
    utils.setTitle('熊猫签证用户协议');
  },
};
</script>

<style lang="less" scoped>
.policy-wrap {
  min-height: 100%;
  background-color: white;
  letter-spacing: 0.0015rem;
  padding: 0.2rem 0.1rem;
}

.center {
  text-align: center;
}

h3 {
  font-size: 0.15rem;
  font-weight: 600;
  color: #444;

  small {
    font-size: 0.12rem;
    font-weight: normal;
    color: #888;
  }
}

h4 {
  font-weight: 600;
  margin-top: 0.15rem;
  font-size: 0.14rem;

  & + p {
    margin-top: 0.05rem;
  }
}

p {
  line-height: 1.5;
  text-indent: 2em;
  font-size: 0.14rem;
}
</style>
